<template>
	<form class="documents-form" enctype="multipart/form-data" @submit.prevent="submitForm">
		<input type="hidden" name="debt" value="1" v-if="$store.state.sidebars.documentFormType === 'debt'">
		<input type="hidden" name="payment" value="1" v-if="$store.state.sidebars.documentFormType === 'payment'">
		<div class="icon">
			<i class="fa-thin fa-file-contract"></i>
		</div>
		<errors-list :errors="errors"/>
		<div class="form-row">
			<default-field-box type="text" name="name" :label="$t('forms.document_title')" :required="true" :has-error="errors?.name?.length"/>
		</div>
		<div class="form-row">
			<field-box name="document_category_id" :label="$t('forms.category')" type="select" :has-error="errors?.document_category_id?.length"
			           :options="documentCategoriesOptions"/>
		</div>
		<div class="form-row" v-if="documentSubCategoriesOptions.length">
			<field-box name="document_sub_category_id" :label="$t('forms.sub_category')" type="select" :has-error="errors?.document_sub_category_id?.length"
			           :options="documentSubCategoriesOptions"/>
		</div>
		<div class="form-row">
			<field-box name="company_code" :label="$t('forms.company')" type="select" :options="companiesOptions" :has-error="errors?.company_code?.length"
			           :key="companyKey"/>
		</div>
		<div class="form-row">
			<field-box name="number" :label="$t('forms.document_number')" type="text" :has-error="errors?.number?.length"/>
		</div>
		<div class="form-row two-columns">
			<field-box name="total_amount" :label="$t('forms.total_amount')" type="text" :has-error="errors?.total_amount?.length"/>
			<field-box name="signature_date" :label="$t('forms.signature_date')" type="date" :has-error="errors?.signature_date?.length"/>
		</div>
		<div class="form-row">
			<field-box name="payment_frequency" :label="$t('forms.payment_frequency')" type="select" :has-error="errors?.payment_frequency?.length"
			           :options="paymentsFrequencyOptions"/>
		</div>
		<div class="form-row two-columns" v-if="paymentFrequency !== 'once'">
			<field-box name="recurring_amount" :label="$t('forms.recurring_amount')" type="text" :has-error="errors?.recurring_amount?.length"/>
			<notification-field :type="paymentFrequency"/>
		</div>
		<div class="form-row two-columns">
			<field-box name="valid_from" :label="$t('forms.valid_from')" type="date" :has-error="errors?.valid_from?.length"/>
			<field-box name="valid_to" :label="$t('forms.valid_to')" type="date" :has-error="errors?.valid_to?.length"/>
		</div>
		<debts-fieldset v-show="showDebtsFieldset"/>
		<dropzone-box name="attachments[]" :label="$t('forms.upload_documents')" url="api/documents/attachment"/>
		<div class="form-row">
			<checkbox-switcher name="agent_visibility" :label="$t('forms.agent_visibility')"
			                   icon='<i class="fa-thin fa-circle-check"></i>' :checked="true"/>
		</div>
		<div class="form-actions">
			<button class="button style-4" type="submit" :class="loading ? 'loading' : ''">
				<span class="inner">{{ $t('forms.save') }}</span>
			</button>
			<button class="button style-1" type="button" @click="$store.commit('HIDE_DOCUMENTS_CREATE_FORM')">
				<span class="inner">{{ $t('forms.cancel') }}</span>
			</button>
		</div>
	</form>
</template>

<script>
	import ErrorsList from "../containers/ErrorsList";
	import FieldBox from "../form-fields/FieldBox";
	import NotificationField from "../form-fields/NotificationField";
	import DropzoneBox from "../form-fields/DropzoneBox";
	import CheckboxSwitcher from "../form-fields/CheckboxSwitcher";
	import DefaultFieldBox from "../form-fields/DefaultFieldBox";
	import DebtsFieldset from "@/components/fieldsets/DebtsFieldset.vue";
	import { trackEvent } from '@/analytics';
	import clientConfirmMixin from "@/mixins/clientConfirmMixin";

	export default {
		name: "DocumentsCreateForm",
		mixins: [clientConfirmMixin],
		components: {
			ErrorsList,
			FieldBox,
			NotificationField,
			DropzoneBox,
			CheckboxSwitcher,
			DefaultFieldBox,
			DebtsFieldset,
		},
		data() {
			return {
				loading: false,
				errors: false,
				paymentFrequency: 'once',
				document_category_id: '',
				companyKey: 0,
				companies: [],
				company_name: '',
				paymentsFrequencyOptions: [
					{
						value: '',
						title: this.$t('forms.choose_option')
					},
					{
						value: 'monthly',
						title: this.$t('forms.monthly')
					},
					{
						value: 'quarterly',
						title: this.$t('forms.quarterly')
					},
					{
						value: 'half_yearly',
						title: this.$t('forms.half_yearly')
					},
					{
						value: 'yearly',
						title: this.$t('forms.yearly')
					},
					{
						value: 'once',
						title: this.$t('forms.once')
					},
				]
			}
		},
		watch: {
			companiesOptions() {
				this.companyKey++;
			}
		},
		computed: {
			notificationOptions() {
				let options = [];
				for (let i = 1; i <= 31; i++) {
					options.push({
						value: i,
						title: i
					});
				}

				return options;
			},
			documentCategoriesOptions() {
				let categories = [];
				categories.push({
					value: '',
					title: this.$t('forms.choose_option')
				});

				if(this.$store.state.sidebars.documentFormType === 'debt'){
					let category = this.$store.state.views.document_categories.find(item => item.code === 'debts');
					categories.push({
						value: category.id,
						title: category.name
					});
				} else {
					this.$store.state.views.document_categories.forEach(item => {
						categories.push({
							value: item.id,
							title: item.name
						});
					});
				}


				return categories;
			},
			documentSubCategoriesOptions() {
				if(!this.document_category_id){
					return [];
				}

				let category = this.$store.state.views.document_categories.find(item =>{
					return item.id == this.document_category_id;
				});

				if(!category || !category.children.length){
					return [];
				}

				let options = [];
				options.push({
					value: '',
					title: this.$t('forms.choose_option')
				});
				category.children.forEach(item => {
					options.push({
						value: item.id,
						title: item.name
					});
				});

				return options;
			},
			companiesOptions() {
				let companies = [];
				if (!this.companies.length) {
					companies.push({
						value: '',
						title: this.$t('forms.choose_category_first')
					});

					return companies;
				}

				companies = this.companies;
				companies.unshift({
					value: '',
					title: this.$t('forms.choose_option')
				});

				return companies;
			},
			showDebtsFieldset(){
				let category = this.$store.state.views.document_categories.find(item => item.id === parseInt(this.document_category_id));
				if(!category || category.code !== 'debts'){
					return false;
				}

				return true;
			}
		},
		methods: {
			async submitForm(e) {
				if (!(await this.confirmAddAsChosenClient())) {
					return;
				}

				let form = e.target;
				let formData = new FormData(form);
				formData.append('company_name', this.company_name);

				this.loading = true;
				trackEvent('form_submit', { form_name: 'document_create', module: 'documents' });
				this.axios.post('/api/documents', formData).then(response => {
					this._submitSuccess = true;
					trackEvent('form_submit_success', { form_name: 'document_create', module: 'documents' });
					this.resetForm(form);
					this.loading = false;

					const formType = this.$store.state.sidebars.documentFormType;

					if (formType === 'debt' || formType === 'payment') {
						if (response.data.document.code === 'debts'){
							this.$store.commit('ADD_DEBT', response.data.document);
						}

						this.$store.commit('ADD_PAYMENT', response.data.document);
					} else {
						this.$store.dispatch('increaseDocumentCategoryCount', response.data.document.document_category_id);
						this.$router.push(`${this.$t('routes.documents.path')}/${response.data.document.document_category_id}`);
					}

					this.$store.commit('HIDE_DOCUMENTS_CREATE_FORM');
				}).catch(error => {
					trackEvent('form_submit_error', {
						form_name: 'document_create',
						module: 'documents',
						error_message: error.response && error.response.data ? error.response.data.message : error.message,
						error_status: error.response ? String(error.response.status) : null,
					});
					this.$swal.fire({
						icon: 'error',
						title: 'Oops',
						text: error.response.data.message
					});

					if (error.response.data.errors) {
						this.errors = error.response.data.errors;
					}

					this.loading = false;
				});
			},
			resetForm(form) {
				form.reset();

				let attachmentInputs = form.querySelectorAll('input[name="attachments[]"]');
				if (attachmentInputs.length) {
					for (let attachmentInput of attachmentInputs) {
						attachmentInput.parentNode.removeChild(attachmentInput);
					}
				}

				let dzPreviews = form.querySelectorAll('.dz-preview');
				if (dzPreviews.length) {
					for (let dzPreview of dzPreviews) {
						dzPreview.parentNode.removeChild(dzPreview);
					}
				}

				let dropzone = form.querySelector('.dropzone');
				if (dropzone) {
					dropzone.classList.remove('dz-started');
				}
			},
			processPaymentFrequency(data) {
				this.paymentFrequency = data.value;
			},
			processDocumentCategory(data) {
				this.document_category_id = data.value;
				this.companies = [];

				if (this.document_category_id === '') {
					return false;
				}

				this.axios.post('/api/document-categories/get-companies', {
					document_category_id: this.document_category_id,
				}).then(response => {
					if (!response.data.companies) {
						return false;
					}

					Object.keys(response.data.companies).forEach(key => {
						if (key === '0') {
							return;
						}

						this.companies.push({
							value: key,
							title: response.data.companies[key].title,
						});
					});

					this.companies.push({
						value: 'other',
						title: this.$t('forms.other'),
					});
				}).catch(() => {
					this.$swal.fire({
						icon: 'error',
						title: 'Oops',
						text: this.$t('general.default_error')
					});
				});
			},
			processCompany(data) {
				if (!data.value || !data.title) {
					this.company_name = '';
					return false;
				}

				this.company_name = data.title;
			}
		},
		mounted() {
			this._submitSuccess = false;
			trackEvent('form_open', { form_name: 'document_create', module: 'documents' });
			this.$root.$on('field-changed', (data) => {
				switch (data.name) {
					case 'payment_frequency':
						this.processPaymentFrequency(data);
						break;
					case 'document_category_id':
						this.processDocumentCategory(data);
						break;
					case 'company_code':
						this.processCompany(data);
						break;
				}
			});
		},
		beforeDestroy() {
			if (!this._submitSuccess) {
				trackEvent('form_close', { form_name: 'document_create', module: 'documents' });
			}
		},
		destroyed() {
			this.$root.$off('field-changed');
		}
	}
</script>

<style scoped lang="scss">
	.documents-form {
		display: flex;
		flex-direction: column;
		flex-grow: 1;
	}

	.form-group {
		label {
			font-size: 12px;
			text-align: center;
			text-transform: uppercase;
			font-weight: 600;
		}
	}


	.icon {
		text-align: center;
		font-size: 21px;
		margin-bottom: 10px;

		&:last-child {
			margin-bottom: 0;
		}
	}

	.form-row {
		margin-bottom: 15px;

		&:last-child {
			margin-bottom: 0;
		}

		&.two-columns {
			display: flex;
			justify-content: space-between;
			flex-direction: row;

			.field-box {
				width: calc(50% - 8px);
			}
		}
	}

	.form-actions {
		margin-top: auto;
		display: flex;
		flex-direction: column;

		.button {
			margin-bottom: 10px;

			&:last-child {
				margin-bottom: 0;
			}
		}
	}

	@media($mobileS) {
		.form-actions {
			margin-top: 25px;
		}
		.form-row {
			margin-bottom: 10px;

			&.two-columns {
				flex-direction: column;

				.field-box {
					width: 100%;
					margin-bottom: 10px;

					&:last-child {
						margin-bottom: 0;
					}
				}
			}
		}
	}
</style>